import * as constants from "./constants";

// Nouvelles actions pour la vérification de crédit avant recherche
export const checkCreditAndSearchRequest = (searchValue, companyId) => {
    return { type: constants.CHECK_CREDIT_REQUESTING, searchValue, companyId }
}

export const checkCreditSuccess = (payload) => {
    return { type: constants.CHECK_CREDIT_SUCCESS, payload }
}

export const checkCreditFailed = (error) => {
    return { type: constants.CHECK_CREDIT_FAILED, error }
}

export const checkCreditInsufficient = (creditData) => {
    return { type: constants.CHECK_CREDIT_INSUFFICIENT, payload: creditData }
}

export const resetCreditStatus = () => {
    return { type: constants.RESET_CREDIT_STATUS }
}

//For search
export const searchRequest = (payload) => {
    return { type: constants.SEARCH_REQUESTING, payload }
}

export const searchRequestAlerte = (payload) => {
    return { type: constants.SEARCH_REQUESTING_ALERTE, payload }
}

export const searchSuccess = (payload) => {
    return { type: constants.SEARCH_SUCCESS, payload }
}

export const searchEmpty = () => {
    return { type: constants.SEARCH_EMPTY }
}

export const searchFailed = (error) => {
    return { type: constants.SEARCH_FAILED, error }
}

//For search details
export const searchDetailRequest = (payload) => {
    return { type: constants.SEARCH_DETAIL_REQUESTING, payload }
}

export const searchDetailSuccess = (payload) => {
    return { type: constants.SEARCH_DETAIL_SUCCESS, payload }
}

export const searchDetailFailed = (error) => {
    return { type: constants.SEARCH_DETAIL_FAILED, error }
}

export const resetSearchDetailState = () => {
    return { type: constants.RESET_SEARCH_DETAIL_STATE }
}

//Decision pour le demandeur
export const searchDecisionApplicantsRequest = (payload) => {
    return { type: constants.SEARCH_DECISION_APPLICANTS_REQUESTING, payload }
}

export const searchDecisionApplicantsSuccess = (payload) => {
    return { type: constants.SEARCH_DECISION_APPLICANTS_SUCCESS, payload }
}

export const searchDecisionApplicantsFailed = (error) => {
    return { type: constants.SEARCH_DECISION_APPLICANTS_FAILED, error }
}

export const paginateSearchDecisionApplicantsRequest = (url, denomination) => {
    return { type: constants.PAGINATE_SEARCH_DECISION_APPLICANTS_REQUESTING, url, denomination }
}

export const paginateSearchDecisionApplicantsSuccess = (payload) => {
    return { type: constants.PAGINATE_SEARCH_DECISION_APPLICANTS_SUCCESS, payload }
}

export const paginateSearchDecisionApplicantsFailed = (error) => {
    return { type: constants.PAGINATE_SEARCH_DECISION_APPLICANTS_FAILED, error }
}

//Decision pour le defendeur
export const searchDecisionDefendantsRequest = (payload) => {
    return { type: constants.SEARCH_DECISION_DEFENDANTS_REQUESTING, payload }
}

export const searchDecisionDefendantsSuccess = (payload) => {
    return { type: constants.SEARCH_DECISION_DEFENDANTS_SUCCESS, payload }
}

export const searchDecisionDefendantsFailed = (error) => {
    return { type: constants.SEARCH_DECISION_DEFENDANTS_FAILED, error }
}

export const paginateSearchDecisionDefendantsRequest = (url, denomination) => {
    return { type: constants.PAGINATE_SEARCH_DECISION_DEFENDANTS_REQUESTING, url, denomination }
}

export const paginateSearchDecisionDefendantsSuccess = (payload) => {
    return { type: constants.PAGINATE_SEARCH_DECISION_DEFENDANTS_SUCCESS, payload }
}

export const paginateSearchDecisionDefendantsFailed = (error) => {
    return { type: constants.PAGINATE_SEARCH_DECISION_DEFENDANTS_FAILED, error }
}

//Autre decision pour le demandeur
export const searchOthersApplicantsRequest = (payload) => {
    return { type: constants.SEARCH_OTHERS_APPLICANTS_REQUESTING, payload }
}

export const searchOthersApplicantsSuccess = (payload) => {
    return { type: constants.SEARCH_OTHERS_APPLICANTS_SUCCESS, payload }
}

export const searchOthersApplicantsFailed = (error) => {
    return { type: constants.SEARCH_OTHERS_APPLICANTS_FAILED, error }
}
export const paginateSearchOthersApplicantsRequest = (url, denomination) => {
    return { type: constants.PAGINATE_SEARCH_OTHERS_APPLICANTS_REQUESTING, url, denomination }
}

export const paginateSearchOthersApplicantsSuccess = (payload) => {
    return { type: constants.PAGINATE_SEARCH_OTHERS_APPLICANTS_SUCCESS, payload }
}

export const paginateSearchOthersApplicantsFailed = (error) => {
    return { type: constants.PAGINATE_SEARCH_OTHERS_APPLICANTS_FAILED, error }
}

//Autre decision pour le defendeur
export const searchOthersDefendantsRequest = (payload) => {
    return { type: constants.SEARCH_OTHERS_DEFENDANTS_REQUESTING, payload }
}

export const searchOthersDefendantsSuccess = (payload) => {
    return { type: constants.SEARCH_OTHERS_DEFENDANTS_SUCCESS, payload }
}

export const searchOthersDefendantsFailed = (error) => {
    return { type: constants.SEARCH_OTHERS_DEFENDANTS_FAILED, error }
}

export const paginateSearchOthersDefendantsRequest = (url, denomination) => {
    return { type: constants.PAGINATE_SEARCH_OTHERS_DEFENDANTS_REQUESTING, url, denomination }
}

export const paginateSearchOthersDefendantsSuccess = (payload) => {
    return { type: constants.PAGINATE_SEARCH_OTHERS_DEFENDANTS_SUCCESS, payload }
}

export const paginateSearchOthersDefendantsFailed = (error) => {
    return { type: constants.PAGINATE_SEARCH_OTHERS_DEFENDANTS_FAILED, error }
}

export const searchDirigeantsDetailRequest = (payload) => {
    return { type: constants.SEARCH_DETAIL_DIRIGEANTS_REQUESTING, payload }
}

export const searchDirigeantsDetailSuccess = (payload) => {
    return { type: constants.SEARCH_DETAIL_DIRIGEANTS_SUCCESS, payload }
}

export const searchDirigeantsDetailFailed = (error) => {
    return { type: constants.SEARCH_DETAIL_DIRIGEANTS_FAILED, error }
}

//ApiKey cart
export const searchAddToCart = (payload) => {
    return { type: constants.SEARCH_ADD_TO_CART, payload }
}

export const searchRemoveFromCart = (payload) => {
    return { type: constants.SEARCH_REMOVE_FROM_CART, payload }
}

//Annonces légales
export const searchAnnoncesRequest = (payload) => {
    return { type: constants.SEARCH_ANNONCES_REQUESTING, payload }
}

export const searchAnnoncesSuccess = (payload) => {
    return { type: constants.SEARCH_ANNONCES_SUCCESS, payload }
}

export const searchAnnoncesFailed = (error) => {
    return { type: constants.SEARCH_ANNONCES_FAILED, error }
}

//Marchés publics
export const searchMarchesPublicsRequest = (payload) => {
    return { type: constants.SEARCH_MARCHES_PUBLICS_REQUESTING, payload }
}

export const searchMarchesPublicsSuccess = (payload) => {
    return { type: constants.SEARCH_MARCHES_PUBLICS_SUCCESS, payload }
}

export const searchMarchesPublicsFailed = (error) => {
    return { type: constants.SEARCH_MARCHES_PUBLICS_FAILED, error }
}

// Pagination Annonces légales
export const paginateSearchAnnoncesRequest = (url) => {
    return { type: constants.PAGINATE_SEARCH_ANNONCES_REQUESTING, url }
}

export const paginateSearchAnnoncesSuccess = (payload) => {
    return { type: constants.PAGINATE_SEARCH_ANNONCES_SUCCESS, payload }
}

export const paginateSearchAnnoncesFailed = (error) => {
    return { type: constants.PAGINATE_SEARCH_ANNONCES_FAILED, error }
}

// Pagination Marchés publics
export const paginateSearchMarchesPublicsRequest = (url) => {
    return { type: constants.PAGINATE_SEARCH_MARCHES_PUBLICS_REQUESTING, url }
}

export const paginateSearchMarchesPublicsSuccess = (payload) => {
    return { type: constants.PAGINATE_SEARCH_MARCHES_PUBLICS_SUCCESS, payload }
}

export const paginateSearchMarchesPublicsFailed = (error) => {
    return { type: constants.PAGINATE_SEARCH_MARCHES_PUBLICS_FAILED, error }
}

// Nouvelle API unifiée pour récupérer toutes les entités liées à une entreprise
export const fetchCompanyEntitiesRequest = (payload) => {
    return { type: constants.FETCH_COMPANY_ENTITIES_REQUESTING, payload }
}

export const fetchCompanyEntitiesSuccess = (payload) => {
    return { type: constants.FETCH_COMPANY_ENTITIES_SUCCESS, payload }
}

export const fetchCompanyEntitiesFailed = (error) => {
    return { type: constants.FETCH_COMPANY_ENTITIES_FAILED, error }
}